import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { Drawer, Box, Grid2, Typography } from '@mui/material'
import MenuImage from '../assets/images/menu.svg';
import NotificationImage from '../assets/images/notification.svg';
import logoMobile from '../assets/images/menu/fullLogo.svg'
import AllEvents from '../assets/images/menu/01.svg';
import MyTickets from '../assets/images/menu/02.svg';
import MyResellTickets from '../assets/images/menu/03.svg';
import Profile from '../assets/images/menu/04.svg';
import AboutUs from '../assets/images/menu/05.svg';
import PrivacyPolicy from '../assets/images/menu/06.svg';
import TermsCondition from '../assets/images/menu/07.svg';
import Logout from '../assets/images/menu/08.svg';
import LogoutPage from './Login/Logout';
import useRequests from "../utils/useRequests";
import Snackbars from "../utils/Snackbars";
import wallet from '../assets/images/wallet-white.svg';

function Header(props) {
    const location = useLocation();
    const TokenDetails = JSON.parse(localStorage.getItem('userDetails'));
    const [loading, setLoading] = useState(true);
    const { getRequest, postRequest } = useRequests();
    const [AlertData, setAlertData] = React.useState({
        variant: "",
        message: "",
      });
      const resetAlertData = () => {
        setTimeout(() => {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: "",
            message: "",
          }));
        }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
      };

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleSidebar = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setSidebarOpen(open);
    };

    const [balance, setBalance] = useState("0.00");
    const fetchWalletBalance = async () => {
    setLoading(true);
    const response = await getRequest("user-wallet");
    if (response && response.code === 200) {
        if(response.data[0]){
            setBalance(response.data[0].balance)
        }
      
    } else {
      setAlertData({ variant: "error", message: "Failed to fetch settings" });
      resetAlertData();
    }
    setLoading(false);
  };


  useEffect(() => {
    fetchWalletBalance();
  },[]);

    return (
        <Grid2 className='header' sx={{ background: "#6638A2" }}>
            <Grid2 className='menu-Link' onClick={toggleSidebar(true)} component={Link} to=""><img src={MenuImage} alt="Navbar" width={180} /></Grid2>
            {AlertData.message !== "" ? (
            <Snackbars variant={AlertData.variant} message={AlertData.message} />
            ) : (
            ""
            )}
            <Typography className='categories-name'>{props.name}</Typography>
            <Grid2 className='position-relative notification' component={Link} to="/wallet-balance" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {location.pathname !== '/wallet-balance' && (
                <Typography sx={{ color: 'white', fontWeight: 'bold', fontSize: '14px' }}>{Number(balance || 0).toFixed(2)}</Typography>
            )}
            <img src={wallet} alt="Wallet" width={24} height={24} />
            </Grid2>


            {/* Sidebar Drawer */}
            <Drawer anchor="left" open={sidebarOpen} onClose={toggleSidebar(false)}>
                <Box sx={{ width: 280, height: '100%' }} role="presentation" onClick={toggleSidebar(false)} onKeyDown={toggleSidebar(false)} >
                    <Box className="menu-logo"><img src={logoMobile} alt='' /></Box>                    
                    <ul className='menu'>

                        <li><Link to="/dashboard"><img src={AllEvents} alt="Logout" width={25} style={{ marginTop: '-4px' }} /> All Events</Link></li>
                        {TokenDetails.guestMode == false ? <li><Link to="/my-tickets"><img className='largeImage' src={MyTickets} alt="Logout" width={25} />My Tickets</Link></li>
                        :""}
                        {TokenDetails.guestMode == false ? <li><Link to="/my-resell-tickets"><img className='largeImage' src={MyResellTickets} alt="Logout" width={25} />My Resell Tickets</Link></li>
                        :""}
                        {TokenDetails.guestMode == false ? <li><Link to="/profile"><img src={Profile} alt="profile" width={25} />Profile</Link></li>
                        :""}
                        <li><Link to="/pages/about_us"><img src={AboutUs} alt="aboutus" width={25} />About Us</Link></li>
                        <li><Link to="/pages/privacy_policy"><img src={PrivacyPolicy} alt="policy" width={25} />Privacy Policy</Link></li>
                        <li><Link to="/pages/terms_condition"><img src={TermsCondition} alt="terms&coonditions" width={25} />Terms & Conditions</Link></li>
                        {/* <li><Link to="/"><img src={Logout} alt="Logout" width={25} /> Logout</Link></li> */}
                        <LogoutPage /> 
                    </ul>
                </Box>
            </Drawer>
        </Grid2>

    );
}

export default Header;